import { MessageMedium, SubscriptionPolicy } from '../../domain';
import { ExtendedMessageType, ExtendedChannel } from '../types';
import { filterByMedium } from './filterByMedium';
import { filterByPolicy } from './filterByPolicy';
import { filterBySearch } from './filterBySearch';
import { filterByStatus } from './filterByStatus';

type FilterOptions = {
  channels: ExtendedChannel[];
  messageTypes: ExtendedMessageType[];
  policies: SubscriptionPolicy[];
  statuses: boolean[];
  mediums: string[];
  search: string;
};

const isMedium = (value: string): value is MessageMedium =>
  Object.values(MessageMedium).includes(value as MessageMedium);

export const applyFilters = ({
  channels,
  messageTypes,
  policies,
  search,
  statuses,
  mediums,
}: FilterOptions) => {
  let filteredChannels = [...channels];
  let filteredMessageTypes = [...messageTypes];

  // FILTER: search
  if (search.length) {
    const [updatedChannels, updatedMessageTypes] = filterBySearch(
      search,
      filteredChannels,
      filteredMessageTypes,
    );
    filteredChannels = updatedChannels;
    filteredMessageTypes = updatedMessageTypes;
  }

  // FILTER: policy
  if (policies.length) {
    const [updatedChannels, updatedMessageTypes] = filterByPolicy(
      policies,
      filteredChannels,
      filteredMessageTypes,
    );
    filteredChannels = updatedChannels;
    filteredMessageTypes = updatedMessageTypes;
  }

  // FILTER: status ( no need to filter if no value is selected or if both are)
  if (statuses.length === 1) {
    const [updatedChannels, updatedMessageTypes] = filterByStatus(
      statuses[0],
      filteredChannels,
      filteredMessageTypes,
    );
    filteredChannels = updatedChannels;
    filteredMessageTypes = updatedMessageTypes;
  }

  // FILTER: medium
  if (mediums.length) {
    const media = mediums.filter(isMedium);
    const [updatedChannels, updatedMessageTypes] = filterByMedium(
      media,
      filteredChannels,
      filteredMessageTypes,
    );
    filteredChannels = updatedChannels;
    filteredMessageTypes = updatedMessageTypes;
  }

  return {
    filteredChannels,
    filteredMessageTypes,
  };
};
